export const FLAGS_BASE_URL = 'https://feature-flags.caterdesk.dev'
